export const querySizeMappings = {
	xs: 30,
	sm: 40,
	md: 48,
	lg: 64,
	xl: 80,
	"2xl": 96,
	"2k": 128,
} satisfies Record<string, number>;
